export default __webpack_public_path__ + "static/media/woman.f6184fa2.png";